/**
 * Service d'orientation — réponses statiques.
 * Les appels IA ont été supprimés ; les fonctions retournent des réponses
 * prédéfinies pour ne pas casser les composants UI existants.
 */

const FALLBACK_ASSISTANT = {
  '/homepage': "Je suis là pour vous aider avec votre orientation ! Pouvez-vous me dire quel domaine vous intéresse le plus ?",
  '/lycee-orientation': "Les filières du lycée offrent chacune des opportunités uniques. Parlez-moi de vos matières préférées pour que je puisse vous conseiller.",
  '/post-bac-database': "Pour trouver l'établissement idéal, pensez à vos préférences : domaine d'études, ville, type d'établissement. Que recherchez-vous ?",
  '/institution-details': "Je peux vous aider à comprendre les détails de cet établissement. Avez-vous des questions spécifiques sur les programmes ou l'admission ?",
  '/admission-calendar': "Les échéances d'admission sont cruciales. Je peux vous aider à organiser votre planning. Quelles sont vos priorités ?",
  '/student-profile': "Un profil complet vous permettra d'avoir des recommandations personnalisées. Avez-vous complété toutes les sections ?",
};

export async function getOrientationAssistantResponse(_userMessage, context = '/homepage') {
  return FALLBACK_ASSISTANT[context] ?? FALLBACK_ASSISTANT['/homepage'];
}

export async function getPersonalizedRecommendations(_userProfile, _query) {
  return {
    recommendations: [
      {
        title: 'Exploration des filières',
        description: "Je recommande d'explorer les différentes filières disponibles selon vos intérêts.",
        priority: 'high',
        category: 'orientation',
      },
    ],
    summary: "Des recommandations personnalisées vous aideront à faire les meilleurs choix d'orientation.",
    next_steps: ['Complétez votre profil', 'Explorez les filières', 'Consultez les établissements'],
  };
}

export async function analyzeUserQuestion(_question, _context) {
  return {
    question_type: 'general_info',
    suggested_actions: ["Explorez les différentes sections de l'application"],
    relevant_pages: ['/homepage', '/lycee-orientation'],
    confidence: 0.5,
  };
}
